import React from 'react';
import { Link } from 'react-router-dom';
import { translations } from '../utils/translations';
import { CyberRiskLogo360 } from '../assets/image';

const TermsOfService = () => {
  const t = translations.eng;

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div style={styles.logoContainer}>
          <img src={CyberRiskLogo360} alt={t.termsOfService} style={styles.logo} height={120} />
        </div>
        <h1 style={styles.title}>{t.termsOfService}</h1>
        <div style={styles.subtitle}>{t.cyberRiskReport}</div>
      </div>

      <div style={styles.content}>
        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <div style={styles.sectionNumber}>1</div>
            <h2 style={styles.sectionTitle}>{t.scopeOfService}</h2>
          </div>
          <p style={styles.text}>{t.scopeDescription}</p>
        </div>

        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <div style={styles.sectionNumber}>2</div>
            <h2 style={styles.sectionTitle}>{t.useOfService}</h2>
          </div>
          <p style={styles.text}>{t.useDescription}</p>
        </div>

        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <div style={styles.sectionNumber}>3</div>
            <h2 style={styles.sectionTitle}>{t.dataHandling}</h2>
          </div>
          <p style={styles.text}>{t.dataDescription}</p>
        </div>

        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <div style={styles.sectionNumber}>4</div>
            <h2 style={styles.sectionTitle}>{t.intellectualProperty}</h2>
          </div>
          <p style={styles.text}>{t.ipDescription}</p>
        </div>

        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <div style={styles.sectionNumber}>5</div>
            <h2 style={styles.sectionTitle}>{t.limitationOfLiability}</h2>
          </div>
          <p style={styles.text}>{t.liabilityDescription}</p>
        </div>

        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <div style={styles.sectionNumber}>6</div>
            <h2 style={styles.sectionTitle}>{t.modificationAndTermination}</h2>
          </div>
          <p style={styles.text}>{t.modificationDescription}</p>
        </div>

        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <div style={styles.sectionNumber}>7</div>
            <h2 style={styles.sectionTitle}>{t.governingLaw}</h2>
          </div>
          <p style={styles.text}>{t.lawDescription}</p>
        </div>
      </div>

      <div style={styles.footer}>
        <div style={styles.footerContent}>
          <Link to="/" style={styles.backButton}>← {t.backToHome}</Link>
          <div style={styles.copyright}>© {new Date().getFullYear()} {t.copyrightText}</div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: '#f8fafc',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
  },
  header: {
    backgroundColor: '#ffffff',
    padding: '24px 0',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
    textAlign: 'center',
    borderBottom: '1px solid #e2e8f0',
  },
  logoContainer: {},
  logo: {
    filter: 'drop-shadow(0 0 8px rgba(0,0,0,0.3))',
  },
  title: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#111827',
    margin: '8px 0 0 0',
    background: 'linear-gradient(90deg, #1e40af, #2563eb)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    display: 'inline-block',
  },
  subtitle: {
    fontSize: '16px',
    color: '#64748b',
    fontWeight: '500',
    marginTop: '4px',
  },
  content: {
    flex: 1,
    padding: '32px 24px',
    maxWidth: '800px',
    width: '100%',
    margin: '0 auto',
  },
  section: {
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    padding: '24px',
    marginBottom: '20px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
    border: '1px solid #e2e8f0',
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
  },
  sectionNumber: {
    backgroundColor: '#2563eb',
    color: 'white',
    width: '28px',
    height: '28px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '12px',
    fontWeight: '600',
    fontSize: '14px',
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#1e293b',
    margin: 0,
  },
  text: {
    fontSize: '15px',
    color: '#475569',
    lineHeight: '1.6',
    margin: 0,
  },
  footer: {
    backgroundColor: '#ffffff',
    padding: '20px 24px',
    borderTop: '1px solid #e2e8f0',
    marginTop: '32px',
  },
  footerContent: {
    maxWidth: '800px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  backButton: {
    color: '#2563eb',
    textDecoration: 'none',
    fontWeight: '500',
    fontSize: '14px',
  },
  copyright: {
    color: '#64748b',
    fontSize: '14px',
  },
};

export default TermsOfService;
